// extracted by mini-css-extract-plugin
export default {"main_container":"ProductContent_main_container__Ilj0T"};